export default function Reasons() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            インフォレスタが選ばれる理由
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-shadow">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl flex-shrink-0">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  40年以上の信頼と実績
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  医療・製薬・研究分野に特化し、年間数万件以上の論文入手に対応。
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-shadow">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl flex-shrink-0">
                <i className="ri-flashlight-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  PDFなら最短15分のスピード納品
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  緊急の学会資料・医師面談・社内報告書にも対応。
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-shadow">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl flex-shrink-0">
                <i className="ri-earth-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  海外・国内、OA／非OA すべて対応
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  PubMed／出版社／学会誌・商業誌／大学図書館ルートをすべて網羅。
                </p>
                <p className="text-gray-500 text-sm mt-2">
                  ※一部の雑誌については入手ができない場合がございます
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-shadow">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl flex-shrink-0">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  出版社ルール完全準拠の安全性
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  コンプライアンスに基づく正規ルートで入手。第三者提供をする企業ユーザーにも安心。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}